// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
// JS Imports
import { formatFloatAsCurrencySymbol } from '../../../common/helpers.mjs'
// Asset Imports

export default function ResellerImplementationRow() {
   const state = useQuoteContext()
   const { getString } = state

   if (state.hrImplementationCosts.totalPrice > 0)
      return (
         <div className='row'>
            <div className='col-bhr1 col-bhr5'>
               <b>{getString('product.ResellerImplementationRow.Title')}</b>
            </div>
            <div className='col'></div>
            <div className='col'></div>
            <div className='col'>
               <b>
                  {formatFloatAsCurrencySymbol(
                     state.totalImplementationCosts.totalPrice,
                     state.currencyObject,
                  )}
               </b>
            </div>
         </div>
      )
}
